import React, { useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import usFlag from "../../assets/flags/us.svg";
import usActive from "../../assets/flags/us-active.svg";
import esFlag from "../../assets/flags/es.svg";
import esActive from "../../assets/flags/es-active.svg";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = useCallback(
    (lng) => {
      try {
        i18n.changeLanguage(lng);
        localStorage.setItem("i18nextLng", lng);
      } catch (error) {
        console.error("Error changing language:", error);
      }
    },
    [i18n]
  );

  useEffect(() => {
    if (!i18n.language || i18n.language !== "en") {
      i18n.changeLanguage("es");
    } 
    const savedLanguage = localStorage.getItem("i18nextLng") || "es";
    changeLanguage(savedLanguage);
  }, [i18n, changeLanguage]);

  return (
    <div className="flex gap-2">
      {i18n.language && (
        <>
          <button
            onClick={() => changeLanguage("en")}
            className={`flex items-center px-4 py-2 rounded-md text-base font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 gap-2 ${
              i18n.language === "en"
                ? "bg-secondary text-white"
                : "bg-buttonFalse text-gray-600"
            }`}
          >
            EN
            <img
              src={i18n.language === "en" ? usActive : usFlag}
              alt="US Flag"
              className="w-6 h-4 ml-2 rounded-sm"
            />
          </button>
          <button
            onClick={() => changeLanguage("es")}
            className={`flex items-center px-4 py-2 rounded-md text-base font-medium transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 gap-2 ${
              i18n.language === "es"
                ? "bg-secondary text-white"
                : "bg-buttonFalse text-gray-600"
            }`}
          >
            ES
            <img
              src={i18n.language === "es" ? esActive : esFlag}
              alt="ES Flag"
              className="w-6 h-4 ml-2 rounded-sm"
            />
          </button>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;
